var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatlaunch1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8659_2844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10.663C21 6.439 16.959 3 12 3C7.041 3 3 6.439 3 10.663C3 14.446 6.201 17.621 10.527 18.223C11.58 18.462 11.459 18.867 11.223 20.356C11.184 20.594 11.039 21.288 12 20.868C12.96 20.448 17.18 17.667 19.073 15.388C20.377 13.884 21 12.359 21 10.673V10.663Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8659_2844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatlaunch1);
export default __webpack_public_path__ + "static/media/chatlaunch-1.bf0037123d322e4bb7fd03cba632a6dd.svg";
export { ForwardRef as ReactComponent };